<div class="typeform-container typeform-bg">
  <div #typeformContainer class="typeform-bg"></div>
</div>
